export default {
    CARD: 'card'
  }
  